<template>
  <div class="table-list__footer">
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :layout="layout"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    total: [Number, String],
    layout: {
      type: String,
      default: 'total, prev, pager, next, jumper'
    },
    pageSize: [Number, String],
    currentPage: [Number, String],
    options: [Object]
  },
  methods: {
    // handleCurrentChange
    handleCurrentChange (page) {
      this.$emit('currentChange', page)
    }
  }
}
</script>


<style>
</style>


// WEBPACK FOOTER //
// widghtPagination.vue?3e2f9d00